import { render } from "./Points.vue?vue&type=template&id=d66ff944&lang=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
script.render = render

export default script